import {
    GET_CARD_TYPE_DEF,
    GET_CARD_TYPE_DEF_SUCCESS,
    CARD_TYPE_DEF_API_ERROR
  } from "./actionTypes"
  
  export const getCardTypeDefList = () => ({
    type: GET_CARD_TYPE_DEF,
  })
  
  export const getCardTypeDefListSuccess = record => ({
    type: GET_CARD_TYPE_DEF_SUCCESS,
    payload: record,
  })

  export const cardTypeDefApiError = error => {
    return {
      type: CARD_TYPE_DEF_API_ERROR,
      payload: error,
    }
  }
  